import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

import { connect } from 'react-redux';
import { change, formValueSelector } from 'redux-form'
import { FormattedMessage, injectIntl } from 'react-intl';

import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent';
import CommonImageDisplay from '../../CommonImageDisplay/CommomImageDisplay';

import { doRemoveLocation, doUploadLocation, startLocationUploaderLoader, endLocationUploaderLoader } from '../../../../actions/siteadmin/manageLocationImage';
import { photosShow } from '../../../../helpers/photosShow';
import { locationuploadDir } from '../../../../config.js';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';

import cs from '../../../../components/commonStyle.css';
import s from './Uploader.css';
import messages from '../../../../locale/jsonMessages';
class Uploader extends React.Component {

  static propTypes = {
    values: PropTypes.any,
    locationUploaderLoading: PropTypes.bool,
    loading: PropTypes.bool,
    doRemoveLocation: PropTypes.any.isRequired,
  };

  static defaultProps = {
    locationUploaderLoading: false,
  };

  success = async (file, fromServer) => {
    const { doUploadLocation, values, change, startLocationUploaderLoader, endLocationUploaderLoader, demoRestriction } = this.props;
    let fileName = fromServer.file.filename;
    let oldPicture = values?.image != null ? values?.image : null;
    let filePath = fromServer.file.path;
    let image = fileName;
    const isRestrict = await demoRestriction({ restrictType: 'popularLocation', restrictValue: values?.id });
    if (isRestrict) return;
    await startLocationUploaderLoader();
    doUploadLocation(image, filePath, oldPicture, values?.id);
    await change('EditPopularLocation', 'image', fileName);
    await endLocationUploaderLoader();
  }

  render() {
    const { doRemoveLocation, locationUploaderLoading, values, imageName } = this.props;
    const { formatMessage } = this.props.intl;

    let loading = true, path;
    if (values) {
      loading = false;
    }
    path = photosShow(locationuploadDir);

    return (
      <div>
        <CommonImageDisplay
          loading={loading}
          loader={locationUploaderLoading}
          isDefaultPic={values?.image ? false : true}
          isDelete={false}
          image={imageName && path + imageName}
        />

        <ImageUploadComponent
          defaultMessage={formatMessage(messages.clickHeretoUploadImage)}
          componentConfig={{
            iconFiletypes: ['.jpg', '.png'],
            multiple: false,
            showFiletypeIcon: false,
            postUrl: '/uploadLocation'
          }}
          loaderName={'locationUploaderLoading'}
          success={this.success}
          className={cs.spaceTop3}
        />
      </div>
    );
  }
}

const selector = formValueSelector('EditPopularLocation');

const mapState = (state) => ({
  locationUploaderLoading: state.loader.locationUploaderLoading,
  imageName: selector(state, 'image')
});

const mapDispatch = {
  doRemoveLocation,
  startLocationUploaderLoader,
  endLocationUploaderLoader,
  doUploadLocation,
  change,
  demoRestriction
};

export default compose(injectIntl, withStyles(s, cs), connect(mapState, mapDispatch))(Uploader);